import { BetResponseCode } from '@pascal/pascal-core/shared/core/enums/ResponseCodes';
import { ValidationType } from './validationType';

export const BetResponseCodes = {
  [ValidationType.InvalidToken]: BetResponseCode.InValidToken,
  [ValidationType.InvalidSpin]: BetResponseCode.InvalidBet,
  [ValidationType.MoneyTransactionError]: BetResponseCode.MoneyTransactionError,
  [ValidationType.NotEnoughMoney]: BetResponseCode.InsufficientFunds,
  [ValidationType.InvalidOperation]: BetResponseCode.ResultNotFound,
  [ValidationType.SpinNotFound]: BetResponseCode.ResultNotFound,
  [ValidationType.InvalidSpinCount]: BetResponseCode.ResultNotFound,
  [ValidationType.InvalidAmount]: BetResponseCode.InValidBetData,
  [ValidationType.BuyBonusDisabled]: BetResponseCode.InValidBetData,
  [ValidationType.PartnerNotFound]: BetResponseCode.PartnerGameConfigNotFound,
  [ValidationType.Success]: BetResponseCode.Success,
  [ValidationType.InvalidSpinResult]: BetResponseCode.ResultNotFound,
  [ValidationType.BonusAlreadyExists]: BetResponseCode.InValidBetData,
  [ValidationType.PlayerLimitExceeded]: BetResponseCode.PlayerLimitExceeded,
  [ValidationType.InvalidRange]: BetResponseCode.InValidBetData,
  [ValidationType.InvalidIndex]: BetResponseCode.InValidBetData,
  [ValidationType.InvalidData]: BetResponseCode.InValidBetData,
  [ValidationType.InvalidSpinData]: BetResponseCode.InValidBetData,
};

export const AdditionalErrorMessages = {
  TicketAdded: 'TICKET_NOTIFICATION',
  MaxNumberCount10: 'MAX_NUMBER_COUNT_10',
  MaxNumberCount8: 'MAX_NUMBER_COUNT_8',
  MaxTicketsCountCode: 'MAX_TICKETS_COUNT',
  MaxBetExceeded: 'MAX_BET_EXCEEDED',
};

export const AdditionalNotificationByResponseCode = {
  TicketAdded: 'accept',
  MaxNumberCount10: 'warning',
  MaxNumberCount8: 'warning',
  MaxTicketsCountCode: 'warning',
  MaxBetExceeded: 'warning',
};

export const AdditionalResponseCode = {
  1007: 'TicketAdded',
  1008: 'MaxNumberCount10',
  1009: 'MaxNumberCount8',
  1010: 'MaxTicketsCountCode',
  1011: 'MaxBetExceeded',
};
export const AddTicketsCode = 1007;
export const MaxNumberCount10 = 1008;
export const MaxNumberCount8 = 1009;
export const MaxTicketsCountCode = 1010;
export const MaxBetExceeded = 1011;
